import { EMODE_SHOW_ONLY, type INavButton } from '~/components/UiNavigation/UiNav/UiNav.types'
export type TButtonType = 'DEFAULT' | 'WELLBEING_SALE' | 'CAREER' | 'PARTNERS'

export const useNavButton = () => {
  const config = useRuntimeConfig()
  const { locale } = useI18n()
  const route = useRoute()
  const navButtons = ref<INavButton[]>([])
  const BUTTONS = {
    DEFAULT: [
      {
        showOnly: EMODE_SHOW_ONLY.ONLY_PL,
        size: 'small',
        to: `${config.public.directSalesUrl as string}nowa-oferta/produkty`,
        label: 'navigation.ds.label',
        callback: () => {
          (window as any).dataLayer?.push({
            event: 'ds_button_clicked',
            placement: 'navbar',
          })
        },
      } as INavButton,
    ],
    WELLBEING_SALE: [
      {
        showOnly: EMODE_SHOW_ONLY.ALWAYS,
        size: 'small',
        to: '#formularz',
        label: 'navigation.ds.label',

      } as INavButton,
    ],
    CAREER: [
      {
        showOnly: EMODE_SHOW_ONLY.ALWAYS,
        size: 'small',
        to: '#wszystkie-oferty',
        label: 'navigation.career.label',
      },
    ],
    PARTNERS: [
      {
        showOnly: EMODE_SHOW_ONLY.ALWAYS,
        size: 'small',
        to: 'https://sp.benefitsystems.pl/',
        label: 'navigation.partnerLogin.label',
      },
    ],
  }

  const getButtons = (buttonsType: TButtonType) => BUTTONS[buttonsType as keyof typeof BUTTONS]

  const shouldBeShowButton = (mode: EMODE_SHOW_ONLY) => {
    if (mode === EMODE_SHOW_ONLY.ONLY_PL) {
      return locale.value === 'pl'
    }
    return true
  }

  watch(() => locale.value, () => {
    if ((route.name as string)?.includes('career')) {
      navButtons.value = getButtons('CAREER').filter(button => shouldBeShowButton(button.showOnly))
    } else if ((route.name as string)?.includes('wellbeing')) {
      navButtons.value = getButtons('WELLBEING_SALE')
    } else if ((route.name as string)?.startsWith('partners')) {
      navButtons.value = getButtons('PARTNERS')
    } else {
      navButtons.value = getButtons('DEFAULT').filter(button => shouldBeShowButton(button.showOnly))
    }
  }, { immediate: true })

  provide('navButtons', computed(() => navButtons.value))

  return {
    getButtons,
    shouldBeShowButton,
  }
}
